import BooleanIcon from "../components/BooleanIcon";
import VueProgress from 'vue-progress-path';
import '@haogentech/cookie-banner/dist/legacy.umd.js';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.component('boolean-icon', BooleanIcon);
  Vue.use(VueProgress);
  Vue.config.ignoredElements = Vue.config.ignoredElements || [];
  Vue.config.ignoredElements.push('cookie-banner');
});